import { createCachedApiReducer } from '../../../utils/api-state';
import { customerAttributesActions, getUpdateStatedIncomeActions } from './customer-attributes.actions';
import { on } from '@ngrx/store';

export const customerAttributesReducer = createCachedApiReducer(
  customerAttributesActions,
  undefined,
  on(getUpdateStatedIncomeActions.success, (state, { response }) => ({
    ...state,
    response: {
      ...state.response,
      customerProfileIncome: {
        ...state.response.customerProfileIncome,
        customerProvidedIncome: parseFloat(response.customer_provided_income),
        customerProvidedEmploymentStatus: response.customer_provided_employment_status,
        customerProvidedHouseholdIncome: parseFloat(response.customer_provided_household_income),
        isCustomerIncomeAttributeRefreshRequired: response.is_customer_income_attribute_refresh_required,
      },
    },
  }))
);
